import { BUSCAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS, LIMPAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS } from '../../actions/types'

const initialState = undefined

const estadoInicial = {
    enviados: [],
    recebidos: []
}

export default function reducerHistoricosTransferenciasPassageiros (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS: {
      const historicos = action.payload.data;
      if (historicos) {
        return  historicos;
      }
      return estadoInicial
    }

    case LIMPAR_HISTORICOS_TRANSFERENCIA_PASSAGEIROS:
        return estadoInicial;
    
    default: {
      return state
    }
  }
}
